export default __webpack_public_path__ + "49146a9ef922739077c79c36ef09500b.svg";